import { TagsOverlayPhoto, TagsOverlayProps, TagsOverlayTag } from "../types";

const parseTagsOverlayPhoto = (photo: TagsOverlayProps["photo"]): TagsOverlayPhoto => {
	const tags: TagsOverlayTag[] = [];
	for (const tag of photo.tags ?? []) {
		if (
			tag.x == null ||
			tag.y == null ||
			tag.userId == null ||
			tag.width == null ||
			tag.height == null
		) {
			continue;
		}
		tags.push({
			curKey: `${tag.userId}-${tag.x}-${tag.y}-${tag.width}-${tag.height}`,
			__debugColor: tag.__debugColor,
			didSettle: false,
			userId: tag.userId,
			width: tag.width,
			height: tag.height,
			x: tag.x,
			y: tag.y,
			labelDim: null,
			labelPos: null,
		});
	}
	return {
		tags,
	};
};
export default parseTagsOverlayPhoto;
